import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
const HeaderWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  height: "52px",
  padding: "16px 16px 0px 16px"
}));
const ActionButton = styled(Button)(() => ({
  margin: "4px"
}));
const ButtonText = styled("span")(() => ({
  fontWeight: 700,
  fontSize: "11px",
  lineHeight: "16px",
  fontFamily: "Lato"
}));
const DateButton = styled(Button)(() => ({
  padding: "8px 16px",
  border: "1px solid #00624F",
  borderRadius: "100px",
  color: "#00624F",
  fontSize: 11,
  "&:hover": {
    borderColor: "#00624F",
    color: "#00624F",
    background: "#edf8f7"
  }
}));
export {
  ActionButton,
  ButtonText,
  DateButton,
  HeaderWrapper
};
